/**
 * 用户管理相关API服务
 */
export default function(apiClient) {
  return {
    /**
     * 获取用户列表
     * @param {Object} params - 查询参数
     * @returns {Promise} - 返回用户列表的Promise
     */
    getUsers(params) {
      return apiClient.get('/users', { params })
    },

    /**
     * 获取单个用户详情
     * @param {string} id - 用户ID
     * @returns {Promise} - 返回用户详情的Promise
     */
    getUser(id) {
      return apiClient.get(`/users/${id}`)
    },

    /**
     * 创建新用户
     * @param {Object} userData - 用户数据
     * @returns {Promise} - 返回创建结果的Promise
     */
    createUser(userData) {
      return apiClient.post('/users', userData)
    },

    /**
     * 更新用户信息
     * @param {string} id - 用户ID
     * @param {Object} userData - 用户数据
     * @returns {Promise} - 返回更新结果的Promise
     */
    updateUser(id, userData) {
      return apiClient.put(`/users/${id}`, userData)
    },

    /**
     * 删除用户
     * @param {string} id - 用户ID
     * @returns {Promise} - 返回删除结果的Promise
     */
    deleteUser(id) {
      return apiClient.delete(`/users/${id}`)
    }
  }
}